import { api } from '@services';

import Profile, { IProfile, IProfileApiModel } from '@models/Profile.model';

const getProfile = async (): Promise<IProfile> => {
  const { data: profile } = await api.get<IProfileApiModel>('/profile');

  return Profile.fromApiModel(profile);
};

export { getProfile };
